<template>
  <!-- BEGIN: Left Aside -->
  <div id="m_aside_left" class="m-grid__item m-aside-left m-aside-left--skin-light">
    <!-- BEGIN: Aside Menu -->
    <div
      id="m_ver_menu"
      class="m-aside-menu m-aside-menu--skin-dark m-aside-menu--submenu-skin-light"
      data-menu-vertical="true"
      data-menu-scrollable="false"
      data-menu-dropdown-timeout="500"
    >
      <div class="m-menu-profile">
        <div class="user-avatar">
          <img
            v-show="!!profilePictureUrl"
            v-bind:src="profilePictureUrl"
            class="m--img-rounded m--marginless m--img-centered"
            alt
          />
          <img
            v-show="!profilePictureUrl"
            src="./../../public/assets/demo/default/media/img/misc/user_default.jpg"
            class="m--img-rounded m--marginless m--img-centered"
            alt
          />
        </div>
        <div class="user-data col">
          <h5>
            {{`${userData.firstname} ${userData.middlename}
            ${userData.lastname}`}}
          </h5>
          <div>Client ID: {{userData.clientId}}</div>
          <div>Referal code: {{userData.referralCode}}</div>
          <div class="m--space-10"></div>
          <router-link
            v-on:click.native="clickOnItem()"
            v-if="!isDisabled('profile')"
            :to="{ name: 'profile' }"
            class="btn m-btn--pill btn-secondary"
          >View Profile</router-link>
        </div>
      </div>

      <ul class="m-menu__nav m-menu__nav--dropdown-submenu-arrow">
        <li
          v-for="(item,index) in computedMenuList"
          :key="`sidebar-${index}`"
          aria-haspopup="true"
          :class="{'m-menu__item--active': isActive(item.pathName) ,'m-menu__item' : true}"
        >
          <router-link
            v-if="item.linkOutside === undefined || item.linkOutside === false"
            v-on:click.native="clickOnItem()"
            :to="!isDisabled(item.pathName) ? { name: item.pathName } : $route.path"
            class="m-menu__link ifff"
            :class="{disabled : isDisabled(item.pathName)}"
          >
            <i class="m-menu__link-icon" :class="item.icon" v-html="item.iconInner"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{item.name}}</span>
              </span>
            </span>
          </router-link>
          <a
            v-else
            target="_blank"
            :href="item.name !== 'Loan Repayment' ? item.pathName : loanRepaymentLink"
            class="m-menu__link else"
            v-on:click.native="clickOnItem()"
            :class="{disabled : isDisabled(item.pathName)}"
          >
            <i class="m-menu__link-icon" :class="item.icon" v-html="item.iconInner"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{item.name}}</span>
              </span>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <!-- END: Aside Menu -->
  </div>
  <!-- END: Left Aside -->
</template>

<script>
import { mapState } from 'vuex';
import routes from './../api/routes'
import { innnerIcons } from "../utils/innerIcons";

export default {
  data() {
    return {
      menuList: [
        {
          name: "Home",
          pathName: "wallet",
          icon: "icon-home",
          iconInner: innnerIcons.home
        },
        {
          name: "Buy Airtime",
          pathName: "under-construction",
          // pathName: "buy-airtime",
          icon: "icon-airtime",
          iconInner: innnerIcons.airtime
        },
        {
          name: "Send Money",
          pathName: "under-construction",
          // pathName: "send-money",
          icon: "icon-sendmoney",
          iconInner: innnerIcons.sendmoney
        },
        {
          name: "Bills Payment",
          pathName: "under-construction",
          // pathName: 'bills-payment',
          icon: "icon-billspayments",
          iconInner: innnerIcons.bills
        },
        {
          name: "Free Credit Report",
          pathName: "credit-report",
          icon: "icon-creditreport",
          iconInner: innnerIcons.fcr
        },
        {
          name: "Complaints",
          pathName: "complaint",
          icon: "icon-complaint",
          iconInner:
                '<span></span>'
        },
        {
          name: "Contact Us",
          pathName: "contact-us",
          icon: "icon-contactus",
          iconInner: innnerIcons.contact
        },
        {
          name: "Log out",
          pathName: "logout",
          icon: "icon-logout",
          iconInner: innnerIcons.logout
        }
      ]
    };
  },
  computed: {
    ...mapState(['Auth']),
    userData() {
      return this.Auth.user_data
    },
    loanId () {
      const { id, loanStatus } = this.$store.state.Auth.loanDetails
      if(id && ["disbursed", "overdue"].includes(loanStatus)) {
        return id
      }
      return false
    },
    userId () {
      return this.userData.id
    },
    loanRepaymentLink() {
      return this.loanId ? `${routes.loan.loanRedirect}?token=${this.userId}_${this.loanId}` : null
    },
    profilePictureUrl() {
      return this.userData.profilePictureUrl
    },
    computedMenuList(state) {
      const loanMenu =   {
          name: "Loan Repayment",
          linkOutside: true,
          pathName: 'hold',
          icon: "icon-loanrepayment",
          iconInner:
            '<span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span>'
        }
      if (state.loanRepaymentLink && state.menuList.length === 7) {
        state.menuList.splice(4, 0, loanMenu)
      }
      return state.menuList
    }
  },
  methods: {
    clickOnItem() {
      if (window.innerWidth < 993) {
        $("body").removeClass("m-aside-left--on");
        $("#m_aside_left").removeClass("m-aside-left--on");
      }
    },
    isActive(input) {
      return (this.$route.name == input || this.$route.path.includes(input + "/")) && this.$route.name != "under-construction"
    },
    isDisabled(input) {
      return false;
      // return (this.$route.name === 'overdraft' || this.$route.path.includes('overdraft')) && input !== 'logout'
    }
  }
};
</script>
